import {CREATE_MESSAGE_SUCCESS} from "../../reducers/editMessageReducer";


export const createMessageSuccess = (message) =>{
    return {
        type: CREATE_MESSAGE_SUCCESS,
        payload: {message}
    }
}